<template>
  <div class="container mx-auto mt-4 mb-4">
    <div v-if="$page.props.flash.success && show" class="bg-green-100 p-4">
      <div class="flex justify-between">
        <div>
          {{ $page.props.flash.success }}
        </div>
        <div>
          <button type="button" class="" @click="show = false">X</button>
        </div>
      </div>
    </div>
    <div
      v-if="
        ($page.props.flash.error || Object.keys($page.props.errors).length > 0) && show
      "
    >
      <div v-if="$page.props.flash.error" class="bg-red-100 p-4">
        {{ $page.props.flash.error }}
      </div>
      <div v-else class="bg-red-100 p-4">
        <span v-if="Object.keys($page.props.errors).length === 1"
          >There is one form error.</span
        >
        <span v-else
          >There are {{ Object.keys($page.props.errors).length }} form errors.</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    };
  },
  watch: {
    "$page.props.flash": {
      handler() {
        this.show = true;
      },
      deep: true,
    },
  },
};
</script>
